import { statusConexaoState } from "./status-conexao.state";
import { createReducer, on } from "@ngrx/store";
import { atualizarStatusConexao } from "src/app/refact/shared/components/teste-conexao/status-conexao/store/status-conexao.actions";

export const statusConexaoReducer = createReducer(
  statusConexaoState,
  on(atualizarStatusConexao, (state, { conectado }) => {
    if (state.conectado === conectado) return state;
    return { ...state, conectado };
  })
);
